import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import BidAsk from "../BidAsk/BidAsk";
import SymbolInfo from "../SymbolInfo/SymbolInfo";
import { Dialog } from "primereact/dialog";
import Backend from "../../../../Backend/Backend";
import { Dark } from '../../../../Theme/Theme'
import "./ListItem.css";
import Mousetrap from "mousetrap";

const backend = await new Backend().init();

export default function ListItem(props) {  
  const item = props.item;

  const [loading, setLoading] = useState(false);
  const [opensymbolInfo, setOpensymbolInfo] = useState(false);
  const [openbidask, setOpenbidask] = useState(false);

  useEffect(() => {
    Mousetrap.bind("backspace", () => {
      Remmove();
    });

    // Cleanup on unmount
    return () => {
      Mousetrap.unbind("backspace");
    };
  }, []);

  const Remmove = () => {
    if (loading) return; // Prevent multiple requests
    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol_id: item.id,
      symboltype: item.type,
    };

    backend.delete_symbol(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        toast.success(r.message);
        props.close();
        props.reload();
      } else {
        toast.error(r.message);
      }
    });
  };

  const openTickData = () => {
    toast.error("Coming Soon");
    // setOpenbidask(true)
  };

  const openSymbolInfoModal = () => {
    toast.error("Coming Soon");
    // setOpensymbolInfo(true)
  };

  return (
    <div className="ListContainer">
      <div
        className="ListText"
        style={{ color: Dark.buy }}
        onClick={props.buy}
      >
        BUY
      </div>
      <div
        className="ListText"
        style={{ color: Dark.sell }}
        onClick={props.sell}
      >
        SELL
      </div>
      <div
        onClick={Remmove}
        className="ListText"
        style={{
          opacity: loading ? 0.5 : 1,
          pointerEvents: loading ? "none" : "auto",
          userSelect: loading ? "none" : "auto",
        }}
      >
        REMOVE SYMBOL
      </div>

      {/* Uncomment and implement when ready
      <div onClick={openTickData} className="ListText">
        TICK DATA
      </div>

      <div onClick={openSymbolInfoModal} className="ListText">
        SYMBOL INFO
      </div>
      */}

      <Dialog
        visible={openbidask}
        closeOnEscape
        closeIcon
        onHide={() => setOpenbidask(false)}
        className={"modal"}
        id="modal"
        position="center"
        transitionOptions={false}
      >
        <BidAsk />
      </Dialog>

      <Dialog
        visible={opensymbolInfo}
        closeOnEscape
        closeIcon
        onHide={() => setOpensymbolInfo(false)}
        className={"modal"}
        id="modal"
        position="center"
        transitionOptions={false}
      >
        <SymbolInfo item={item} />
      </Dialog>
    </div>
  );
}
